export default function unwrap(nodes) {
  return nodes.get(0).get('children')
}
